import { Alert } from 'Components';

export const handlePasswordChangeApiError = ({ error, t, setUsernameError, setNewPasswordError, setNewPasswordBackendError }) => {
  if (error?.code === 1017) {
    Alert.error(t('Your username, or password is not correct'));
    return;
  }

  if ([1023, 1024, 1025, 1031].includes(error?.code)) {
    const passwordMessage = error?.details?.new_password || error?.message || '';
    if (passwordMessage) {
      setNewPasswordBackendError(passwordMessage);
    }
    setNewPasswordError(true);
    return;
  }

  if ([1001, 1002, 1014].includes(error?.code)) {
    setUsernameError(true);
    Alert.error(error?.message || t('Email or phone number'));
    return;
  }

  if ([1003, 1030, 1800].includes(error?.code)) {
    Alert.error(error?.message || t('Sorry, something went wrong there'));
    return;
  }

  Alert.error(error?.message || t('Sorry, something went wrong there'));
};
